import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import ScheduleMain from '../../components/schedule/ScheduleMain'
import Footer from '../../components/common/Footer'
export default function SchedulePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <ScheduleMain/>
            <Footer/>
        </>
    )
}